'use client';

import { createLogger } from '@svenskaspelab/nova-core/nextjs/log';
import React from 'react';

const logger = createLogger('account-tur:SilentErrorBoundary');

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

// Functional error boundaries require a dependency.
export default class SilentErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    logger.warn(error, info.componentStack);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    return hasError ? null : children;
  }
}
